<template>
    <div >

        
        <v-container fluid px-lg-7 pt-lg-0>
            <h2 class="subheading grey--text mx-0 px-0 pb-5 pt-2">Downloads</h2>

            <v-layout row justify-space-between px-4>
                <v-flex xs12 md8>
                    <v-tooltip top>
                        <v-btn small flat color="grey lighten-3" @click="sortBy('identifier')" slot="activator">
                            <v-icon small left>file_copy</v-icon>
                            <span class="caption text-lowercase">By identifier</span>
                        </v-btn>
                        <span>Sort by identifier</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip top>
                        <v-btn small flat color="grey  lighten-3" @click="sortBy('size')" slot="activator">
                            <v-icon small left>storage</v-icon>
                            <span class="caption text-lowercase">By size</span>
                        </v-btn>
                        <span>Sort by size</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip top>
                        <v-btn small flat color="grey  lighten-3" @click="sortBy('date')" slot="activator">
                            <v-icon small left>date_range</v-icon>
                            <span class="caption text-lowercase">By date</span>
                        </v-btn>
                        <span>Sort by date</span>
                    </v-tooltip>
                </v-flex>

                <!-- <v-flex xs12 md3>
                    <v-select
                        item-text="value"
                        item-value="key"
                        v-model="app"
                        :items="apps"
                        @change="appChanged"
                        label="App"
                        prepend-icon="application"
                        single-line
                        
                    ></v-select>
                </v-flex> -->
            </v-layout>
            <!-- <br> -->
            <v-text-field
                label="Search"
                append-icon="search"
                v-model="searchString"
            ></v-text-field>
            <!-- <br> -->
            <v-card flat v-for="activity in filteredactivities" :key="activity.identifier">
                <v-layout row wrap :class="`pa-3 project `">
                <v-flex xs12  md5>
                    <div class="caption grey--text">Identifier</div>
                    <div>{{ activity.identifier }}</div>
                </v-flex>
                <v-flex xs4 md2>
                    <div class="caption grey--text">Size</div>
                    <div>{{ activity.size | kb}}</div>
                </v-flex>
                <v-flex xs8  md3>
                    <div class="caption grey--text">Date</div>
                    <div>{{ activity.date | formatDate}}</div>
                </v-flex>
                <v-flex xs12  md2>
                    <div class="right">
                        <v-chip small :disabled="!hasUserPermission('bi-downloads-download')" :class="`complete white--text my-2 caption`" @click='signS3URL(activity.identifier)' style='cursor: pointer;'>download</v-chip>
                        &nbsp;
                        <v-chip small :disabled="!hasUserPermission('bi-downloads-delete')" :class="`overdue white--text my-2 caption`" @click='deleteS3Resource(activity.identifier)' style='cursor: pointer;'>delete</v-chip>
                    </div>
                </v-flex>
                
                </v-layout>
                <v-divider></v-divider>
            </v-card>
        <!-- <br> -->
        </v-container>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    filters: {
        kb: function (value) {
            if (!value) return ''
            if(Number(value) > 1000000){
                value = (Number(value) / 1024 / 1024).toFixed(2);
                return value + ' MB';
            }
            else if(Number(value) > 1000){
                value = (Number(value) / 1024).toFixed(2);
                return value + ' KB';
            }
            else{
                return value;
            }
        }
    },
    data: function(){
        return {
            activities: [],
            searchString: '',
            apps: [{key: 205, value: "Direct Mail"}, {key: 2009, value: "HP Smart Stream"}, {key: 3000, value: "Raw Data Extract"}, {key: 3001, value: "Contacts Export"}, {key: 3002, value: "On-Demand Export"}],
            app: 205,
        }
    },
    methods: {
        hasUserPermission: function(policyName){
            //alert(this.$store.getters.user.policies);
            if(this.$store.getters.user.policies.includes(policyName)){
                return true;
            }

            return false;
        },
        appChanged: function() {
            //axios({url: process.env.VUE_APP_EDGE_SERVICE_ENDPOINT + '/api/app-data/v1/downloads/'  + this.app  , method: 'GET' })
            axios({url: process.env.VUE_APP_EDGE_SERVICE_ENDPOINT + '/api/bi/v1/downloads'  , method: 'GET' })
            .then(resp => {
                this.activities = resp.data.files.filter(file => {
                    if(file.identifier.endsWith("000") || file.identifier.endsWith("000.gz") ){
                        return false;
                    }
                    else{
                        return true;
                    }
                });
            })
            .catch(err => {
                
                if(err && err.response && err.response.status && 403 === err.response.status)
                    alert('User has no permission to access downloads.')
                
            })
        },
        signS3URL: function(identifier) {
            //axios({url: process.env.VUE_APP_EDGE_SERVICE_ENDPOINT + '/api/app-data/v1/downloads/' + this.app + '/'  + identifier, method: 'GET' })
            axios({url: process.env.VUE_APP_EDGE_SERVICE_ENDPOINT + '/api/bi/v1/downloads/' + identifier, method: 'GET' })
            .then(resp => {
                window.open(resp.data.url, '_blank'); 
            })
            .catch(err => {
                
                if(err && err.response && err.response.status && 403 === err.response.status)
                    alert('User has no permission to download.')
            })
        },
        deleteS3Resource: function(identifier) {
            //axios({url: process.env.VUE_APP_EDGE_SERVICE_ENDPOINT + '/api/app-data/v1/downloads/' + this.app + '/'  + identifier, method: 'DELETE' })
            axios({url: process.env.VUE_APP_EDGE_SERVICE_ENDPOINT + '/api/bi/v1/downloads/' + identifier, method: 'DELETE' })
            .then(resp => {
                 this.activities.splice(this.activities.findIndex(v => v.identifier === identifier), 1);
            })
            .catch(err => {
                
                if(err && err.response && err.response.status && 403 === err.response.status)
                    alert('User has no permission to delete a download.')
            })
        },
        sortBy(prop) {
            if(prop==="date")
                this.activities.sort((a,b) => a[prop] < b[prop] ? 1 : -1)
            else
                this.activities.sort((a,b) => a[prop] < b[prop] ? -1 : 1)
        }
    },
    computed: {

        account : function(){
            return this.$store.getters.user.account;
        },
        filteredactivities: function () {
            var activities = this.activities,
                searchString = this.searchString;

            if(!searchString){
                return activities;
            }

            searchString = searchString.trim().toLowerCase();

            activities = activities.filter(function(item){
                if(item.identifier.toLowerCase().indexOf(searchString) !== -1){
                    return item;
                }
            })

            // Return an array with the filtered data.
            return activities;
        }
    },
    created: function(){
        this.appChanged();
    },
    watch: {
        account: {
            handler(val){
                this.appChanged();
            },
            deep: true
        }
    },
    mounted(){
        if(this.$route.query.search){
            this.searchString = this.$route.query.search;
        }
    }
    
    
}
</script>

<style>

.project.complete{
  border-left: 4px solid #3cd1c2;
}
.project.ongoing{
  border-left: 4px solid #ffaa2c;
}
.project.overdue{
  border-left: 4px solid #f83e70 !important;
}
.v-chip.complete{
  background: #3cd1c2 !important; 
}
.v-chip.ongoing{
  background: #ffaa2c;
}
.v-chip.overdue{
  background: #f83e70  !important;
}

</style>

